// extracted by mini-css-extract-plugin
export default {"container":"LoadingPage_container__vAnTk"};